<div class="dropdown" [ngClass]="{'show': isShow}">
    <button class="btn dropdown-btn dropdown-toggle" type="button" data-toggle="dropdown" (click)="isShow=!isShow"
        [style.min-width.px]="minWidth || 'auto'">{{
        displaySelectedItem() }}
        <span class="caret"></span></button>
    <ul class="dropdown-menu" [ngClass]="{'show': isShow}">
        <li *ngFor="let item of list" class="parent-item">
            <a (click)="getSelectedItem(item,true,false)"> {{ item[displayField] }}</a>
            <ul *ngIf="item[childListFledName] && item[childListFledName]?.length > 0" class="child-ul">
                <li *ngFor="let child of item[childListFledName]">
                    <a (click)="getSelectedItem(child,false,true)">-&nbsp; {{ child[displayChildField] }}</a>
                </li>
            </ul>
        </li>
    </ul>
</div>